import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

import mainLogo from './assets/logo/ai-logo-white.png'
import mainLogoBlack from './assets/logo/ai-logo-black.png'
import fxLogoWhite from './assets/logo/fx-white.png'
import tulingLogo from './assets/logo/tuling-white.png'
import ccidLogo from './assets/logo/ccid.png'
import cciaLogo from './assets/logo/ccia.png'
import ccidLogoRed from './assets/logo/ccid-red.jpg'
import cocoLogo from './assets/logo/coco.png'
import raicLogo from './assets/logo/raic.png'
import hsjyLogo from './assets/logo/hsjy.png'
import zqckLogo from './assets/logo/zqck.png'
import ksLogo from './assets/logo/ks.png'
import mbbLogo from './assets/logo/mbb.png'
import rmwpLogo from './assets/logo/rmwp.png'
import ywLogo from './assets/logo/yw.png'
import tlLogo from './assets/logo/tl.png'
import qmxLogo from './assets/logo/qmx.png'

import detailImg0 from './assets/image/frontpage/detail0.jpg'
import detailImg1 from './assets/image/frontpage/detail1.jpg'
import detailImg2 from './assets/image/frontpage/detail2.jpg'

import detailImg3 from './assets/image/frontpage/detail3.png'
import detailImg4 from './assets/image/frontpage/detail4.jpg'
import detailImg5 from './assets/image/frontpage/detail5.jpg'

import groupS1 from './assets/image/enroll/group-s1.png'
import groupS2 from './assets/image/enroll/group-s2.png'
import groupM from './assets/image/enroll/group-m.png'

let mediaPhone = window.matchMedia('(min-width: 320px) and (max-width: 480px)').matches

let cocoLink = process.env.VUE_APP_COCO_LINK
let cocoProxyLink = process.env.VUE_APP_COCO_PROXY_LINK
let ozariaLink = process.env.VUE_APP_OZARIA_LINK || 'http://staging.aojiarui.com'
let provider = process.env.VUE_APP_PROVIDER
let Oprovider = process.env.VUE_APP_PROVIDER_O

let cocoClan1 = process.env.VUE_APP_COCO_CLAN_1
let cocoClan2 = process.env.VUE_APP_COCO_CLAN_2
let cocoClan2022 = process.env.VUE_APP_COCO_CLAN_2022
let teacherClan = process.env.VUE_APP_TEACHER_CLAN

let cocoTour1 = process.env.VUE_APP_COCO_TOUR_1 || '601e1657120e5b0028ebabba'
let cocoTour2 = process.env.VUE_APP_COCO_TOUR_2 || '601e16d9120e5b0028ebabc4'

console.log(ozariaLink)
let redirect = process.env.VUE_APP_REDIRECT
let statisticCode = process.env.VUE_APP_STATISTICS

let loginLink = cocoLink + '/auth/login-o-auth?provider=' + provider
let loginOzaria = ozariaLink + '/auth/login-o-auth?provider=' + provider
let clanLink = '/play/ladder/lava-lake/clan/'

export default new Vuex.Store({
  state: {
    timeDelay: 0,
    procedure: 1, 
    game_slug: '2023-1-p',
    game_year: '2023',
    loginLink: loginLink,
    gamelink: loginLink + '&accessToken=',
    ozarialink: loginOzaria + '&accessToken=',
    cocoLink: cocoLink,
    statisticCode: statisticCode,
    mediaPhone: mediaPhone,
    noHeader: false,
    noFooter: false,
    classrooms: [],
    allScore: [],
    auth: {
      user: null,
      token: null,
      classroom: {},
      game_state: {},
      csrf: ''
    },
    route: {
      redirect: ''
    },
    input: {
      enroll: {
        area: {province: '北京', id: 1, city: '东城'},
        group: 1,
        invite: '',
        lang: 'python'
      }
    },
    'hbar': {
      'links': [{text: '首页', link: {name: 'frontpage'}},
                {text: '报名入口', link: {name: 'enroll'}},
                {text: '查询奖项', link: {name: 'reward'}, disable: false },
                {text: '成绩排名', link: {name: 'score'}},
                {text: '赛制规则', link: {name: 'rule'}},
                {text: '大赛新闻', link: {name: 'news'}},
                {text: '关于我们', link: {name: 'aboutus'}},
                {text: '常见问题', link: {name: 'problem'}},
                {text: 'CodeQuest', link: 'https://codequest.koudashijie.com'},
                // {text: '竞赛辅导', link: 'https://xuetang.koudashijie.com'}
                // {text: '图灵计划', link: 'https://www.turingyouth.com'}
               ],
      'login': {text: '登录', link: {name: 'account', params: {type: 'login'}}},
      'register': {text: '免费注册', link: {name: 'account', params: {type: 'register'}}},
      // 'version': {text: '教师专项赛', link: 'https://python.koudashijie.com'}
    },
    'sbar': {
      'linksFP': [
        // {text: '开始报名', link: {name: 'enroll'}, disable: true},
        // {text: '开始比赛', link: {name: 'Preliminary'}},
        // {text: '查看成绩', link: {name: 'score'}},
        {text: '查询奖项', link: {name: 'reward'}, disable: false},
        {text: '常见问题', link: {name: 'problem'}},
      ],
      'linksRule': [
        // {text: '开始报名', link: {name: 'enroll'}},
        // {text: '开始比赛', link: {name: 'Preliminary'}},
        // {text: '查看成绩', link: {name: 'score'}},
        {text: '常见问题', link: {name: 'problem'}},
        // {text: '规则下载', link: '/oss/pdf/%E2%80%9C%E6%89%A3%E5%93%92%E6%9D%AF%E2%80%9D%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD%E5%A4%A7%E8%B5%9BAI%E4%B8%96%E9%9D%92%E8%B5%9B%E8%A7%84%E5%88%99.pdf'}
      ]
    },
    'news': {
      news: []
    },
    'problem': {
      questions: [
        {question: '编程挑战活动的性质是什么？', answer: '活动坚持公益性，不以盈利为目的，不作为中小学入学依据，让孩子在快乐中探索编程的的魅力，和全球2000万扣哒世界学习者切磋交流计算机知识，培养他们迎难而上的精神和团队协作能力，不以营利为目的。以赛促学。面向世界，面向未来。'},
        {question: 'AI算法挑战活动如何报名？', answer: '登录活动官网，点击首页右上角的报名注册，有问题可以联系客服进行报名咨询'},
        {question: '如何与活动主办方联系？', answer: '您可以关注网站底部公众号，在后台留言或者提问， 也可以扫描首页左侧微信客服二维码'},
        {question: '此次挑战活动是以什么形式进行？', answer: '本次挑战活动，使用扣哒世界CodeCombat平台，第一阶段以线上完成挑战任务，第二阶段也是线上竞技形式，具体请参见挑战活动规则说明。'},
        {question: '挑战活动的评分原则是怎样的？', answer: '第一阶段是根据学生在编程竞技场中的代码对战结果进行积分计算和排名'},
        {question: '挑战活动有没有费用？', answer: '活动坚持公益性，不收报名费用。'},
        {question: '孩子多少岁可以参加呢？', answer: '最小5岁，比赛分为4个组别：幼少组（5-7岁）、小学组（1-6年级）、中学组（7-12年级）和开放组（教师、大学生和工作人员）'},
        {question: '没有编程基础是否可以参加？', answer: '挑战活动面向5岁以上大中小学生，无编程基础也可以参加，在参加活动的过程中学习编程知识'},
        {question: '年龄组别如何选择?', answer: '以当月所在的年级为准。'},
        {question: '第一阶段在规定时间内可以多次更改代码吗？', answer: '可以，活动指定时间内，注册进入报名入口即可开始挑战，第一阶段结束前可反复挑战。'},
        {question: '第一阶段和第二阶段如何获得积分？', answer: '第一阶段：通过代码竞技场比拼，参赛选手在任务一取得正分及以上分数，或者完成任务二，即可晋级第二阶段。第二阶段：会根据比例确定最终晋级名单。'},
        {question: '挑战活动中如何查看我的排名？', answer: '账户未登录时，仅可查看全国排名（各组别前100名），登录后可查看按地区排名情况。'}
      ]
    },
    'score': {
      myrank: [],
      rank: {
        title: ['排名', '昵称',  '积分', '学校/机构', '省市'],
        school_title: ['排名', '学校/机构', '总积分'],
        infos: {
          's1': [
            [1, '陈木夕', '123', '山西省运城市']
          ],
          's2': [
            [3, '李子旋', '120', '山西省运城市']
          ],
          'm': [
            [3, '杨依然', '120', '山西省运城市']
          ]
        }
      },
      juniorRank: {
        title: ['昵称',  '沙滩精灵', '学校/机构', '省市'],
      },
      finalRank: {
        title: ['排名', '昵称', '积分','学校/机构', '省市'],
        school_title: ['排名', '学校/机构', '总积分'],
      }
    },
    'aboutus': {
      'desc': [
        '全球青少年人工智能算法挑战活动是由AI算法挑战活动全国组委会联合扣哒世界、扣哒人工智能学院、全球青少年图灵计划联合主办，全球数十家STEAM/青少年编程教育机构和知名院校联合协办或积极参与的科普公益赛事，2023年5月1日全球启动。',
      ],
      'org': {
        'title': '大赛组织结构',
        'info': {
          '主办单位': ['扣哒世界', '扣哒人工智能学院', '全球青少年图灵计划'],
          // '支持单位': ['少年硅谷', '图灵计划', '智能体大赛'],
          '协办单位': ['斯坦星球', '苏州数字公民计划等'],
          '竞赛合作':[ '中国计算机协会', '清华大学', '斯坦福大学'],
          '竞赛平台':['扣哒世界(CodeCombat)']
        }
      },
      'support': {
        'title': '大赛组织委员会',
        'info': {
          '' : ['扣哒世界、扣哒人工智能学院 、全球青少年图灵计划，负责本次公益挑战活动的组织、宣传、推广、指导和落地。落实本届科普公益大赛工作，履行大赛职责。'],
          '电子邮箱': ['china@codecombat.com'],
          // '客服QQ': ['1011635189']
        }
      },

      ptable: {
        titles: [{text: '省/直辖市', w: '6vw'},
                 {text: '市', w: '6vw'},
                 {text: '大赛服务协办点', w: '16vw'},
                 {text: '电话', w: '12vw'},
                 {text: '地址', w: '22vw'},
                 {text: '详细介绍', w: '6vw'}],
        infos: [
          ['深圳市', '龙岗区', '编玩时光教育科技有限公司', '13316924697(周)', '深圳市龙岗区布吉街道布沙路佳兆业可园6A-603'],
          ['辽宁省', '沈阳', '华斯教育信息咨询有限公司', '13998300199(王)', '辽宁省沈阳市沈河区佳兆业大厦C座1807'],
          ['四川省', '成都', '酷思未来教育科技有限公司', '028-67876390(张)', '四川省成都市锦江区晨辉二街26号'],
          ['重庆市', '渝北区', '图灵教育科技有限公司', '023-65552278', '重庆市渝北区金童路100-5-4'],
          ['浙江省', '杭州', '码爸爸编程创客中心', '18969090235(刘)', '杭州上城区富春路132号昆仑中心A座6楼'],
          ['福建省', '福州', '一瓦教育科技有限公司', '0591-86129060(陈)', '福州市五四路环球广场5楼 '],
          ['山东省', '青岛市', '青岛极客启明星青少年编程学校', '13365321791(李)', '青岛市市南区动漫产业园A座209B'],
          ['宁夏', '银川', '智途教育信息咨询有限公司', '18995089318(何)', '银川市金凤区凤凰北街天玺国际B北座532']
        ],
        details: [
          ['深圳市编玩时光教育科技有限公司，成立于2016年，由毕业于中山大学计算机专业的周老师发起创建，旨在让中国学生的编程学习多些快乐，少些弯路。',
           '”乐码无派”既是我们的品牌标识，又是我们的教学理念，即：快乐编码、无派无界，我们期望让少儿编程多些中国色，以”编程”为主线，教授孩子更多的知识与道理。',
           '编程是孩子未来发展的关键变量，编程教育的早接触、早学习，已是各国的普遍共识，欢迎加入乐码无派少儿编程俱乐部，一起探索神秘的编程世界吧！'],
          ['华斯教育得名于中国及斯坦福大学 ，旨在培养国际化人才。创始人毕业于斯坦福大学，团队成员来自欧美顶尖学府，致力于为中国教育产业注入国际尖端教育产品，为中国及世界输出具有国际视野的青少年。'],
          ['酷思少儿编程——四川省嘉祥教育集团旗下少儿编程教育专业领导品牌，专注为中国5-12少儿提供全球最先进的编程教育，帮助孩子应对未来挑战，在世界舞台脱颖而出。',
           '以美国CSTA(中小小学计算机科学教学)标准为基石，原版引起美国Workshop、日本Sony Education等全球最先进少儿编程课程体系。'],
          ['重庆图灵教育科技有限公司是一家由资深教育人士全力打造的，致力于STEAM教育的专业教育集团。现专注于少儿编程教育，独家引进了拥有1200万学习者的全球青少年Python编程第一品牌CodeCombat，面向全社会广泛招生。'],
          ['国际科技创新联盟会员单位',
           '美国大学理事会认证的青少年编程教育平台CodeCombat的核心合作伙伴',
           '码爸爸编程创客中心致力于为孩子们打造符合欧美K-12教育体系、新一代人工智能发展规划以及新高考自主招生等教育领域发展平台，实现孩子们的信息素养与Steam教育破冰，携手孩子和家长迈入面向2025后的全球化教育目标！'],
          ['一瓦少儿编程由深耕行业多年的STEAM教育专家创立运营，引进欧美先进教育理念和课程平台，致力于打造成为青少年人工智能素质培育中心。专注7-16岁青少年人工智能通识教育，让孩子从编程开始编写未来。'],
          ['青岛极客启明星青少年编程学校成立于2016年，是青岛第一家以青少年编程课程为主的专业学校，以全国青少年信息学奥赛（NOIP）和全国中小学生科技创新与实践活动（NOC）辅导为核心课程。我们联合大学的专业师资力量，针对中小学生量身定制辅导竞赛类课程，旨在竞赛中获取奖项，增强孩子们的竞争优势，参加中高考自主招生及综合评价招生，提高孩子逻辑思维能力、及综合学科素质能力。'],
          ['宁夏智途教育信息咨询有限公司（蒸汽创客SteamLeader）致力于基于STEAM的青少年编程创客教育，是宁夏第一家编程教育培训公司，目前团队有35人，在长期读学生500余人，以编程入校形式和宁夏42家重点中小学长期合作，承办了宁夏地区青少年创意编程与智能设计大赛、蓝桥杯、NOC创意编程大赛、科技创新大赛编程赛项等多个地区权威比赛。']
        ]
      }
    },
    'enroll': {
      areas: {},
      groups: [
        {text: '小学组', key: 's', index: 0, extra: '.', img: groupS1},
        {text: '中学组', key: 'm', index: 1,  extra: '（初中和高中）', img: groupS2},
        {text: '开放组', key: 'l', index: 2, extra: '.', img: groupM},
      ],
      egroup: {text:'教师组', key: 't', extra: '.'},
      languages: ['python', 'javascript', 'c++'],
      notice: [
        '1. 活动分为小学组、中学组（初中、高中）以及开放组。\n编程零基础也可参赛。 注：参赛选手年级以当月年级为准',
        '2.大赛指定时间内，注册进入报名入口即可开始挑战，初赛结束前可反复挑战。',
        '3.比赛必须通过本网站进入挑战游戏页面，其他路径进入成绩无效。',
        '4.如果报名信息有误，申请修改资料，请扫描网页底部微信公众号二维码咨询',
        // '5.报名时间截止为12月15日 17:59'
      ],
      link: cocoProxyLink + '/account/oauth-aiyouth?provider=' + provider + '&token='
    },
    'account': {
      'register': {
        'links': [
          {text: '返回首页', link: {name: 'frontpage'}},
          {text: '去登录', link: {name: 'account', params: {type: 'login'}}}
        ],
        'forms': [
          {label: 'phone', type:'text', placeholder: '请填写 11 位手机号'},
          {label: 'code', type:'text', placeholder: '请输验证码'},
          {label: 'name', type:'text', placeholder: '输入昵称(建议使用真实姓名)'},
          {label: 'password', type:'password', placeholder: '请输入密码，长度6位以上'},
          {label: 'password_confirmation', type:'password', placeholder: '请确认密码'},
        ]
      },
      'certification': {
        'links': [
          {text: '返回首页', link: {name: 'frontpage'}},
          {text: '退出登录', link: ''}
        ],
        'forms': [
          {label: 'name', type: 'text', placeholder: '真实姓名'},
          {label: 'idcard', type: 'text', placeholder: '身份证号'},
          {label: 'organization', type: 'text', placeholder: '参赛单位（选填）'},
        ]
      },
      'modifyInfo': {
        'links': [
          {text: '返回首页', link: {name: 'frontpage'}},
          {text: '退出登录', link: ''}
        ],
        'forms': [
          {label: 'realname', type: 'text', placeholder: '真实姓名'},
          {label: 'organization', type: 'text', placeholder: '学校/机构'},
        ]
      },
      'password': {
        'links': [
          {text: '返回首页', link: {name: 'frontpage'}},
          {text: '退出登录', link: ''}
        ],
        'forms': [
          {label: 'password', type: 'password', placeholder: '请输入新密码，长度6位以上'},
          {label: 'password_confirmation', type: 'password', placeholder: '请重复一遍密码'}
        ]
      },

      'login': {
        'links': [
          {text: '返回首页', link: {name: 'frontpage'}},
          {text: '去注册', link: {name: 'account', params: {type: 'register'}}}
        ],
        'forms': [
          {label: 'phone', type: 'text', placeholder: '手机号'},
          {label: 'password', type: 'password', placeholder: '请输入密码'}
        ]
      },
      'loginWithCode': {
        'links': [
          {text: '返回首页', link: {name: 'frontpage'}},
          {text: '去登录', link: {name: 'account', params: {type: 'login'}}}
        ],
        'forms': [
          {label: 'phone', type: 'text', placeholder: '手机号'},
          {label: 'code', type: 'text', placeholder: '请输入验证码'}
        ]

      }
    },
    'frontpage': {
      'title': {
        main: '全球青少年人工智能算法挑战活动',
        sub: '（中国赛区）',
        button: 'end'
      },
      'info': {
        'activity': {
          'content': {
            title: '活动介绍',
            text: '为深入贯彻落实国务院《新一代人工智能发展规划》的任务要求，逐步开展全民智能教育项目、普及推广编程教育，提高我国全民对人工智能的认知和初步应用能力。培养复合型人才，形成我国人工智能人才高地，并积极培养新一代适应社会发展的人才。赛迪研究院培训中心联合CodeCombat共同举办赛迪人工智能大赛，并于2019年开展首届青少年编程组挑战活动(以下简称“活动”)。'
          },

          'style': {
            content: {
              'box-sizing': 'border-box',
              width: mediaPhone? '100vw':'66.56vw',
              height: mediaPhone? '29.75vw': '19.8vw',
              // 'background-image': 'url('+require('./assets/image/frontpage/info-activity.png')+')',
              'background-image': 'url("/oss/images/frontpage/info-activity.png")',
              'background-size': mediaPhone? '100vw':'66.56vw',
              padding: '3.6vw 10.4vw',
              'font-size': mediaPhone? '1.8vw': '0.9375vw'
            }
          }
        },
        orgStyle: {
          content: {
            'box-sizing': 'border-box',
            width: mediaPhone? '28vw': '19vw',
            height: mediaPhone? '37.08vw': '25.16vw',
            padding: '2.5vw',
            'justify-content': 'flex-start'
          },
          logoDiv: {
            'height': '4.2vw'
          },
          title: {
            'font-size': mediaPhone? '2vw' : '1vw',
            'position': 'absolute',
            top: '8vw',
            'background-image': 'none',
            width: '100%'
          },
          text: {
            'font-size': mediaPhone? '1.6vw': '0.9vw',
            'margin-top': '5vw'
          }
        }
      },
      rewards: [
        /*
        {
          color: '#9046CF',
          icolor: '#EFBB24',
          icon: 'medal',
          title: '金牌',
          subTitle: '5 名/组别',
          content: '2000元扣哒之星奖学金'
        },
        {
          color: '#CC59D2',
          icolor: '#91989F',
          icon: 'medal',
          title: '银牌',
          subTitle: '10 名/组别',
          content: '1500元扣哒之星奖学金'
        },
        {
          color: '#F487B6',
          icolor: '#A28C37',
          icon: 'medal',
          title: '铜牌',
          subTitle: '20 名/组别',
          content: '1200元扣哒之星奖学金'
        },
        */
        {
          color: '#FAE3C6',
          icolor: '#EFBB24',
          icon: 'award',
          title: '全国一等奖',
          subTitle: '前10%/组别',
          content: '1000元扣哒之星奖学金'
        },
        {
          color: '#FDE12D',
          icolor: '#91989F',
          icon: 'award',
          title: '全国二等奖',
          subTitle: '前30%/组别',
          content: '800元扣哒之星奖学金'
        },
        {
          color: '#6CCFF6',
          icolor: '#A28C37',
          icon: 'award',

          title: '全国三等奖',
          subTitle: '前70%/组别',
          content: '500元扣哒之星奖学金'
        },

      ],
      highlights: {
        images: [
          {
            desc: 'AP国际认证平台',
            src: '/oss/images/frontpage/pic-hl0.png'},
          {
            desc: '国际人工智能营',
            src: '/oss/images/frontpage/2023/pic-hl1.png'
          },
          {
            desc: '人大高瓴英才项目',
            src: '/oss/images/frontpage/2023/pic-hl2.png'
          },
          {
            desc: '竞赛获奖证书',
            src: '/oss/images/frontpage/2023/pic-hl3.png'
          },
        ],
        bgStyle: {
          width: mediaPhone? '20vw': '14.43vw',
          'background-size': mediaPhone? '20vw': '14.43vw',
          height: mediaPhone? '15.5vw': '11.2vw'
        }
      },
      process: [
        {
          time: {
            year: '举办月份',
            date: '3-5、9-11'
          },
          event: {
            main: '省市赛马拉松赛',
            sub: ''
          }
        },{
          time: {
            year: '举办月份',
            date: '6、12'
          },
          event: {
            main: '全国决赛马拉松赛',
            sub: ''
          }
        }, {
          time: {
            year: '举办月份',
            date: '1、7'
          },
          event: {
            main: '全国决赛奖项揭晓',
            sub: '宣布图灵计划科技营入营名单'
          }
        },
        {
          time: {
            // year: '举办月份',
            date: '7月和1月中旬'
          },
          event: {
            main: '金牌附加赛',
            sub: '奖牌选手可保送人大/国科大/斯坦福英才科技营'
          }
        }, {
          time: {
            date: '寒暑假'
          },
          event: {
            main: '图灵计划科技营'
          }
        }
      ],
      detail: {
        progresses: [ {
          content: {
            title: '比赛详情',
            text: [
              '省市赛',
              '扣哒世界计算机二级难度，选手可以采用扣哒世界教学版计算机科学二级（CS2)或个人版codecombat.cn第二个模块《森林》进行集训练习。',

              '全国决赛',
              '扣哒世界计算机三级难度，选手可以采用扣哒世界教学版计算机科学三级（CS3)或个人版codecombat.cn第三个模块《沙漠》进行集训练习。',
              '金牌附加赛',
              '扣哒世界计算机四级难度，选手可以采用扣哒世界教学版计算机科学四级（CS4)或个人版codecombat.cn第四个模块《山峰》进行集训练习。'
            ]
          },

          style: {
            content: {
              // 'background-image': 'url('+require('./assets/image/frontpage/sbg-detail.png')+')',
              'background-image': 'url("/oss/images/frontpage/sbg-detail.png")',
              'box-sizing': 'border-box',
              'background-size': '100vw',
              width: '100vw',
              height: '30.02vw',
              padding: '4vw 22.5vw 4vw 24vw',
              'justify-content': 'flex-start'

            },
            title: {
              color: '#6C4DFF'
            },
            text: {
              'margin-top': '1.8vw',
              color: '#4D4D4D'
            }
          }},
                      {
                        content: {
                          title: '英才科技营',
                          text: [
                            '图灵英才营',
                            '中国人民大学高瓴人工智能学院主办，中国人民大学科技孵化器和扣哒世界联合承办，旨在发现、挖掘、培养和追踪在计算机技术领域富有潜力的中小学生。',
                            '国科大科技营',
                            '中国科学院大学培训中心主办，扣哒世界参与承办，通过参与中科院下属院所的项目实践，旨在培养和提升青少年科研兴趣和科技素养。',
                            '斯坦福竞赛营',
                            '斯坦福大学和CodeCombat联合发起，通过国际竞赛、游学顶级名校和参观知名科技公司丰富国际视野，提升国际升学竞争力。'
                          ]
                        },
                        style: {
                          content: {
                            'background-image': 'url("/oss/images/frontpage/sbg-detail.png")',
                            'box-sizing': 'border-box',
                            'background-size': '100vw',
                            width: '100vw',
                            height: '30.02vw',
                            padding: '4vw 22.5vw 4vw 24vw',
                            'justify-content': 'flex-start'
                          },
                          title: {
                            color: '#6C4DFF'
                          },
                          text: {
                            'margin-top': '1.8vw',
                            color: '#4D4D4D'
                          }
                        },
                      }
                    ],
        images: [
          detailImg0, detailImg1, detailImg2,
          detailImg3, detailImg4, detailImg5
        ]
      },
      videos: [
        {
          src: '/oss/videos/2021/%E9%A6%96%E9%A1%B5%E8%A7%86%E9%A2%91%E5%B7%A6-AI%E4%B8%96%E9%9D%92%E8%B5%9B2021%E5%AE%A3%E4%BC%A0.mp4',
          title: '扣哒杯AI算法挑战活动2021宣传片',
          poster: '/oss/images/frontpage/2021/2021%E5%AE%A3%E4%BC%A0%E7%89%87.png'
        },
        {
          src: '/oss/videos/2021/%E9%A6%96%E9%A1%B5%E8%A7%86%E9%A2%91%E4%B8%AD-%E8%8B%8F%E5%B7%9E%E5%B8%82%E9%9D%92%E5%B0%91%E5%B9%B4%E7%A7%91%E6%8A%80%E8%8A%82.mp4',
          title: '苏州市青少年科技节',
          poster: '/oss/images/frontpage/%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4%E5%8A%A9%E5%8A%9B%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2.jpg'
        },
        {
          src: '/oss/videos/2021/%E9%A6%96%E9%A1%B5%E8%A7%86%E9%A2%91%E5%8F%B3-%E5%A6%82%E4%BD%95%E5%8F%82%E5%8A%A0AI%E4%B8%96%E9%9D%92%E8%B5%9B2021.mp4',
          title: '如何参加AI算法挑战活动和闯关竞技',
          poster: 'https://assets.koudashijie.com/aiyouth/images/frontpage/video_3_poster.png'
        }
      ]
    },
    'footer': {
      main: {
        title: '主办单位',
        info: [
          {
                 name:'扣哒世界',
                 link: 'https://koudashijie.com'
               },
          {
          name: '扣哒人工智能学院',
          link: 'https://koudashijie.com'
        },

               {
                 name: '全球青少年图灵计划',
                 link: 'http://www.turingyouth.com'
               }]
      },
      support: {
        title: '支持单位',
        info: ['清华大学', '北京大学', '中国科学院大学', '中国人民大学', '斯坦福大学']
      },
      contact: {
        title: '联系我们',
        info: {
          '协办咨询': 'china@codecombat.com',
          '联系客服': '见右侧微信客服',
          '工作时间': '周一～周五9:00 – 17:00，法定节假日除外',
          '单位地址': '北京市海淀区中关村西大街48号一层221号',
          // '客服QQ': '1011635189'
        }
      }
    },
    'bbar': {},
    'logo': {
      'main': {text: 'AI算法挑战活动', icon: mainLogo},
      'mainBlack': {text: 'AI算法挑战活动', icon: mainLogoBlack},
      'ccid': {text: '赛迪研究院培训中心', icon: ccidLogo},
      'ccia': {text: '中国行业计算机协会', icon: cciaLogo},
      'ccidRed': {text: '赛迪研究院培训中心', icon: ccidLogoRed},
      'coco': {text: 'CodeCombat', icon: cocoLogo},
      'raic': {text: 'RAIC雷克大会', icon: raicLogo},
      'fxWhite': {text: '伏羲人工智能实验室', icon: fxLogoWhite},
      'tulingWhite': {text: '', icon: tulingLogo},
      'coco-cn': { text: '扣哒世界', icon: '/oss/logos/coco-cn.png'},
      'kdsj': {text: '扣哒世界', icon: '/oss/logos/kdsj.jpg'},
      'kdxt': {text: '扣哒学堂', icon: '/oss/logos/kdxt.png'},
      'hsjy': {text: '', icon: hsjyLogo},
      'ks': {text: '', icon: ksLogo},
      'mbb': {text: '', icon: mbbLogo},
      'rmwp': {text: '', icon: rmwpLogo},
      'tl': {text: '', icon: tlLogo},
      'yw': {text: '', icon: ywLogo},
      'zqck': {text: '', icon: zqckLogo},
      'qmx': {text: '', icon: qmxLogo}
    },
    'copyright': 'Copyright @2023 CodeCombat ALL Right Reserved.'
  },
  getters: {
    clanLinks: state => {
      return clanLink + cocoClan2022
    },
    organizers: state => {
      return [
        {
          content: {
            logo: state.logo['coco-cn'],
            title: '扣哒世界',
            text: '扣哒世界与全球顶级学府和顶级AI机构合作，为青少年学习编程和人工智能技术定制的优质平台。',
            link: 'https://koudashijie.com/'
          },
          style: {
            content: Object.assign({
              'background': 'linear-gradient(51.7deg, #ee7151, #F1934b)'
            }, state.frontpage.info.orgStyle.content),
            logoDiv: state.frontpage.info.orgStyle.logoDiv,
            logo: {width: '11vw'},
            title: state.frontpage.info.orgStyle.title,
            text: state.frontpage.info.orgStyle.text
          }
        },
        {
          content: {
            logo: state.logo.coco,
            title: 'CodeCombat',
            text: 'AP认证全球广受欢迎的青少年编程教学和学习平台，覆盖全球200多个国家近2000万学习者。',
            link: 'https://codecombat.com/'
          },
          style: {
            content: Object.assign({
              background: 'linear-gradient(51.7deg, rgb(244, 199, 20), rgb(244, 168, 10))'
            }, state.frontpage.info.orgStyle.content),
            logoDiv: state.frontpage.info.orgStyle.logoDiv,
            logo: {width: '11.875vw'},
            title: state.frontpage.info.orgStyle.title,
            text: state.frontpage.info.orgStyle.text
          }
        },
        {
          content: {
            logo: state.logo.tulingWhite,
            title: '图灵计划',
            text: '全球青少年图灵计划是由中国人民大学高瓴人工智能学院等名校发起的青少年人工智能英才培养计划。',
            link: 'http://www.turingyouth.com'
          },
          style: {
            content: Object.assign({
              background: 'linear-gradient(51.7deg, #4ab593, #95e18e)'
            }, state.frontpage.info.orgStyle.content),
            logoDiv: state.frontpage.info.orgStyle.logoDiv,
            logo: {width: '11.875vw'},
            title: state.frontpage.info.orgStyle.title,
            text: state.frontpage.info.orgStyle.text
          }
        },
        /*{
          content: {
          logo: state.logo.raic,
          title: 'RAIC雷克大会',
          text: '雷克(RAIC)是工业和信息化部中国电子信息产业发展研究 院聚焦人工智能领域的新锐品牌。该品牌以人工智能产业创新联盟为依托，成功举办多届雷克大会。现已成为人工智能领域顶尖专 家学者和行业领袖交流研讨、思想激荡的高端平台。',
          link: 'http://www.raictech.com/'
          },
          style: {
          content: Object.assign({
          background: 'linear-gradient(51.7deg, #6442ff, #669ef2)'
          }, state.frontpage.info.orgStyle.content),
          logoDiv: state.frontpage.info.orgStyle.logoDiv,
          logo: {width: '7.55vw'},
          title: state.frontpage.info.orgStyle.title,
          text: state.frontpage.info.orgStyle.text
          }
          }*/
      ]
    },
    coorgLogos: state => {
      let logoList = [
        'stxq.jpg',
        'mkjy.jpg',
        // 'tljh.jpg',
        'xdfzx.png',
        'bjjqr.png',
        'xadc.jpg',
        'tuling.png',
        'mabb.png',
        'zqck.png',
        'beike.png',
        'suzhou.jpeg',
        'angli.png',
        'gaodele.jpeg',
        'kusi.png',
        'qihang.png',
        'Al4kids.png',
        'jikeqmx.jpeg',
        'codewall.png',
        'lechuang.png',
        'cct.png',
        'hsjy.png',
        'lsyz.jpeg',
        'lexue.jpeg',
        'ing.png',
        'kdck.png',
        'micei.png',
        'youfa.png',
        'abilix.jpeg',
        'kdbc.png',
        'aosong.png',
        'MrHow.jpeg',
        'mmyc.png',
        'kdbc.jpg',
        'wljy.png',
        'dshzx.png',
        'sqwgy.jpg',
        'jlzx.png',
        'hzzx.png',
        'hdwgy.png',
        'xalzfx.png',
        'xazx.png',
        'zxzx.jpg',
        'tzzh.png',
        'hrsx.jpg',
        'hlxx.png',
        'wwxq.png',
        'xgjqr.png',
        'dash.png',
        'sdm.png',
        'gsg.png',
        'lbt.png',
        'coderlands.png',
        'wlkjxx.png',
        'bjycxx.png'
      ]
      return logoList.map(d => { return {icon: '/oss/logos/' + d}})
      // return [
      //   state.logo.tl,
      //   state.logo.hsjy,
      //   state.logo.ks,
      //   state.logo.mbb,
      //   state.logo.rmwp,
      //   state.logo.yw,
      //   state.logo.zqck,
      //   state.logo.qmx
      // ]
    }
  },
  mutations: {
    SET_USER(state, user) {
      state.auth.user = user
    },
    SET_TIME(state, time) {
      state.timeDelay = time
    },
    SET_CLASSROOMS(state, classrooms) {
      state.classrooms = classrooms
    },
    SET_MY_CLASSROOM(state, classroom) {
      state.auth.classroom = classroom
    },

    SUCCESS_ENROLLED(state) {
      state.auth.user.enrolled = true
    },
    SET_TOKEN(state, token) {
      state.auth.token = token
    },
    LOGOUT(state) {
      state.auth.user = null
      state.auth.token = ''
    },
    updateEnrollProvince(state, pay) {
      state.input.enroll.area.province = pay.p
      state.input.enroll.area.id = pay.id
    },
    updateEnrollCity(state, c) {
      state.input.enroll.area.city = c
    },
    updateEnrollInvite(state, i) {
      state.input.enroll.invite = i
    },
    updateEnrollOrg(state, i) {
      state.input.enroll.organization= i
    },
    updateEnrollGroup(state, g) {
      state.input.enroll.group = g
    },
    updateEnrollLang(state, l) {
      state.input.enroll.lang = l
    },
    SET_REDIRECT(state, path) {
      state.route.redirect = path
    },
    UNSET_REDIRECT(state) {
      state.route.redirect = ''
    },
    SET_MEDIAPHONE(state, b) {
      state.mediaPhone = b
    },
    SET_GAME_STATE(state, g) {
      state.auth.game_state = g
    },
    SET_GAME_YEAR(state, y) {
      state.game_year = y
    },
    SET_ALL_SCORE(state, a){
      state.allScore = a
    },
    SET_PROCEDURE(state, b) {
      state.procedure = b
    },
    SET_GAME_SLUG(state, b) {
      state.game_slug = b
    },
    SET_HEADER(state, h) {
      state.noHeader = !h
    },
    SET_FOOTER(state, f) {
      state.noFooter = !f
    }
  },
  actions: {},
  plugins: [createPersistedState({
    key: 'aiyouth',
    paths: ['auth', 'timeDelay'],
    storage: window.localStorage
  })]
})
